import React, { useEffect, useState } from "react";
import UserService from "../services/UserService";
import firebase from "../services/FirebaseService";
import { Link } from "react-router-dom";
import Showdown from "showdown";
import ArticleService from "../services/ArticleService";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import "../assets/style/blog.css";
const ArticleList = () => {

	const article = new ArticleService();
	const converter = new Showdown.Converter();
	
	const [ articles, setArticles ] = useState([]);
	const [ pending, setPending ] = useState(true);

	useEffect(() => {
		(async () => {

			if(pending) {
				try {
					const articlesList = await article.fetchArticles();
		
					setArticles(articlesList);
					setPending(false);
				}
				catch(error) {
					console.error(error);
				}
			}
			
		})();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			{ !pending && articles.map(article => 
					<div className="article">
						<h3 className="date">{article.date.toLocaleDateString()}</h3>	
						<div className="content" dangerouslySetInnerHTML={{__html: converter.makeHtml(article.content)}}></div>
						<Link className="more" to={"/blog/article/" + article.id}>Read more</Link>
 					</div>
				)
			}
		</>
	)
}

const Articles = () => {

	const userService = new UserService();

	const [ privileged, setPriviledged ] = useState(0);

	firebase.auth().onAuthStateChanged(async user => {
		
		if(user) {
			const isAdmin = await userService.isUserAdmin(user.uid);

			isAdmin ? setPriviledged(1) : setPriviledged(2);
		}
		else {
			setPriviledged(2);
		}

	});
	return (
		<section id="articles-list">
			{ privileged === 1 && <Link to="/blog/new" id="new-article">New Article</Link> }
			<ArticleList />
		</section>
	)
};

const BlogPage = () => (
	<>
		<Navbar />
		<Articles />
		<Footer />
	</>
);

export default BlogPage;